import React, { FC, memo, useMemo } from "react";

// DLS
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { SpriteIconWeb } from "@swiggy-private/dls-web-icons/dist/SpriteIconWeb";

// constants
import { replaceText } from "@swiggy-private/core-ui";

// helpers
import { isEmpty } from "@swiggy-private/js-utils";

// styles
import styles from "./CroutonText.scss";
import { CroutonTextContainer } from "./styles";

const CroutonText: FC<{ text: string }> = ({ text }) => {
    const formattedText = useMemo(() => replaceText(text, styles.benefitImage), [text]);
    if (isEmpty(text)) {
        return null;
    }

    return (
        <CroutonTextContainer>
            <SpriteIconWeb
                iconName={"tick16"}
                strokeColor="text_inverse_High_Emphasis"
                fillColor="text_inverse_High_Emphasis"
            />
            <Text as="span" variant="V2.body3.neutral.regular" color="text_inverse_High_Emphasis">
                {formattedText}
            </Text>
        </CroutonTextContainer>
    );
};

export default memo(CroutonText);
